import mainImgone from "../../../assets/honey-pvc-wicker-basket.jpeg"; 
import thumb3 from "../../../assets/honey-pvc-wicker-basket.jpeg";
import thumb4 from "../../../assets/honey-pvc-wicker-basket.jpeg";

import mainImg from "../../../assets/white-pvc-wicker-basket.jpeg"; 
import thumb1 from "../../../assets/white-pvc-wicker-basket.jpeg";
import thumb2 from "../../../assets/white-pvc-wicker-basket.jpeg";




import mainImgtwo from "../../../assets/wooden-wicker-basket.jpeg"; 
import thumb5 from "../../../assets/wooden-wicker-basket.jpeg";
import thumb6 from "../../../assets/wooden-wicker-basket.jpeg";

import mainImgthree from "../../../assets/ratten-basket.webp"; 
import thumb7 from "../../../assets/ratten-basket-thumone.webp";
import thumb8 from "../../../assets/ratten-basket-thumtwo.webp";


import mainImgfour from "../../../assets/leather-basket.png"; 
import thumb9 from "../../../assets/leather-basket.png";
import thumb10 from "../../../assets/leather-basket.png";


import mainImg9 from "../../../assets/tandom-attachment-thali.png";
import thumb19 from "../../../assets/tandom-attachment-thali.png";
import thumb20 from "../../../assets/tandom-attachment-thali.png";


import mainImg10 from "../../../assets/soft-close-wicker-basket.webp";
import thumb21 from "../../../assets/soft-close-wicker-basket-thumb-one.webp";
import thumb22 from "../../../assets/soft-close-wicker-basket-thumb-two.webp";

// import mainImg8 from "../../../assets/tandom-attachment-plate.jpg";
// import thumb17 from "../../../assets/tandom-attachment-plate.jpg";
// import thumb18 from "../../../assets/tandom-attachment-plate.jpg";


// import mainImg7 from "../../../assets/tandom-attachments.png";
// import thumb15 from "../../../assets/tandom-attachments.png";
// import thumb16 from "../../../assets/tandom-attachments.png";

// export const products = [
  

  



 
  

//   {
//     code: "7700",
//     name: "Leather Basket",
//     category: "basket",
//     short:
//       "Leather Basket is a premium and stylish storage solution designed to add a touch of elegance to modern interiors. Made from high-quality leather or leather-finish material, it offers durability, strength, and a sophisticated look. The sturdy construction ensures reliable storage while maintaining a sleek and luxurious appearance, making it suitable for kitchens, wardrobes, or living spaces.",
//     features: [
//       "Strong and durable construction for long-term use",
//       "Elegant and modern design that enhances interiors",
//       "Easy to clean and maintain",
//       "Suitable for storing kitchen items, accessories, and essentials",
//       "Code : 7700, 7701",
//     ],
//     faq: [
//   {
//     question: "What is a Leather Basket?",
//     answer:
//       "Leather Basket is a premium kitchen storage basket designed with a leather finish that adds a stylish and modern look while providing organized storage."
//   },
//   {
//     question: "Where is the Leather Basket commonly used?",
//     answer:
//       "It is commonly used in modular kitchens, cabinets, and pantry units for storing groceries, vegetables, and other kitchen essentials."
//   },
//   {
//     question: "What are the advantages of a leather basket?",
//     answer:
//       "Leather baskets offer a premium appearance, durable structure, smooth handling, and organized storage for modern kitchen spaces."
//   },
//   {
//     question: "Is the Leather Basket suitable for modular kitchens?",
//     answer:
//       "Yes, it is designed for modular kitchen cabinets and helps maintain a neat and elegant kitchen storage system."
//   }
// ],
//     mainImage: mainImgfour,
//     thumbnails: [thumb9, thumb10],
//   },



//   {
//       code: "SM-010",
//       name: "Tandom Attachments – Thali",
//       category: "basket",
  
//       mainImage: mainImg9,
  
//       thumbnails: [thumb19, thumb20],
  
//       short:
//         "Tandom Attachments – Thali is a specially designed kitchen drawer organizer made to store thalis safely and neatly inside tandem drawers. Manufactured from high-quality stainless steel or powder-coated material, it ensures durability, strength, and rust resistance. The structured partition design holds thalis firmly in place, preventing scratches and damage. It keeps your kitchen organized while providing easy access and better space utilization. Perfect for modern modular kitchens, this attachment adds convenience and a premium storage solution.",
  
//       features: [
//         "Durable and rust-resistant material",
//         "Designed specifically for thali storage",
//         "Prevents scratches and damage",
//         "Ideal for tandem drawer systems",
//         "Easy to clean and maintain",
//       ],
//       faq: [
//     {
//       question: "What are Tandom Attachments – Thali?",
//       answer:
//         "Tandom Attachments – Thali are modular kitchen storage accessories designed to hold thalis (plates) securely within cabinets or drawers."
//     },
//     {
//       question: "Where are Tandom Attachments – Thali used?",
//       answer:
//         "They are commonly installed in kitchen cabinets or modular drawer systems to organize and safely store thalis and large plates."
//     },
//     {
//       question: "What are the advantages of Tandom Attachments – Thali?",
//       answer:
//         "They prevent thalis from shifting or breaking, maximize cabinet space, keep items organized, and provide easy access."
//     },
//     {
//       question: "What items can be stored using Tandom Attachments – Thali?",
//       answer:
//         "They are ideal for storing thalis, large plates, and round kitchenware in an organized and safe manner."
//     }
//   ],
//     },


//     {
//     code: "SM-09",
//     name: "Tandom Attachments –  Plate",
//     category: "basket",

//     mainImage: mainImg8,

//     thumbnails: [thumb17, thumb18],

//     short:
//       "Tandom Attachments – Cup & Saucer is a specially designed kitchen organizer accessory that provides safe and organized storage for cups and saucers inside tandem drawers. Made from high-quality stainless steel or powder-coated material, it ensures durability, strength, and rust resistance. The smart partition design keeps cups and saucers securely in place, preventing movement and breakage. It maximizes drawer space while maintaining neat and systematic storage. Ideal for modular kitchens, this attachment enhances convenience and adds a premium touch to your kitchen interiors.",

//     features: [
//       "Strong and rust-resistant material",
//       "Prevents slipping and breakage",
//       "Prevents slipping and breakage",
//       "Perfect fit for tandem drawers",
//       "Easy to clean and maintain",
//     ],
//     faq: [
//   {
//     question: "What are Tandom Attachments – Plate?",
//     answer:
//       "Tandom Attachments – Plate are modular kitchen storage accessories designed to hold plates securely within cabinets or drawers."
//   },
//   {
//     question: "Where are Tandom Attachments – Plate used?",
//     answer:
//       "They are commonly installed in kitchen cabinets or modular drawer systems to organize and safely store plates of various sizes."
//   },
//   {
//     question: "What are the advantages of Tandom Attachments – Plate?",
//     answer:
//       "They prevent plates from shifting or breaking, maximize cabinet space, keep plates organized, and provide easy access."
//   },
//   {
//     question: "What items can be stored using Tandom Attachments – Plate?",
//     answer:
//       "They are ideal for storing plates, saucers, shallow bowls, and other flat kitchenware in an organized and safe manner."
//   }
// ],
//   },


//   {
//     code: "SM-08",
//     name: "Tandom Attachments – Cup & Saucer",
//     category: "basket",

//     mainImage: mainImg7,

//     thumbnails: [thumb15, thumb16],

//     short:
//       "Tandom Attachments – Cup & Saucer is a specially designed kitchen organizer accessory that provides safe and organized storage for cups and saucers inside tandem drawers. Made from high-quality stainless steel or powder-coated material, it ensures durability, strength, and rust resistance. The smart partition design keeps cups and saucers securely in place, preventing movement and breakage. It maximizes drawer space while maintaining neat and systematic storage. Ideal for modular kitchens, this attachment enhances convenience and adds a premium touch to your kitchen interiors.",

//     features: [
//       "Strong and rust-resistant material",
//       "Prevents slipping and breakage",
//       "Prevents slipping and breakage",
//       "Perfect fit for tandem drawers",
//       "Easy to clean and maintain",
//     ],
//     faq: [
//   {
//     question: "What are Tandom Attachments – Cup & Saucer?",
//     answer:
//       "Tandom Attachments – Cup & Saucer are modular kitchen storage accessories designed to hold cups and saucers securely within cabinets or drawers."
//   },
//   {
//     question: "Where are Tandom Attachments – Cup & Saucer used?",
//     answer:
//       "They are commonly installed in kitchen cabinets or modular drawer systems to organize and safely store cups, mugs, and saucers."
//   },
//   {
//     question: "What are the advantages of Tandom Attachments – Cup & Saucer?",
//     answer:
//       "They prevent items from shifting or tipping, maximize cabinet space, keep cups and saucers organized, and provide easy access."
//   },
//   {
//     question: "What items can be stored using Tandom Attachments – Cup & Saucer?",
//     answer:
//       "They are ideal for storing cups, mugs, saucers, and small kitchen drinkware in an organized manner."
//   }
// ],
//   },

  
// ];







export const products = [
  {
    code: "7638",
    name: "White PVC Wicket Basket",
    category: "basket",

    mainImage: mainImg,
    thumbnails: [thumb1, thumb2],

    price: "₹2345",
    oldPrice: "₹2659",
    sku: "7638",
    stock: "In Stock",

   catalogue: "/Slimline Price List-2026.pdf",
    inquiry: "https://wa.me/919650100908?text=White PVC Basket Inquiry",

    video: "https://www.youtube.com/embed/PM5WhdOWrqo",

    short:
      "The White PVC Wicket Basket is designed to provide a clean, organized, and durable storage solution for modular kitchens and cabinets.",

    features: [
      "High-quality PVC construction",
      "Waterproof and rust-resistant",
      "Strong and durable design",
      "Modern kitchen compatible",
      "Code : 7638, 7639, 7640"
    ],

    // ✅ NORMAL SPECIFICATIONS
    specifications: [
      { label: "Material", value: "PVC" },
      { label: "Finish", value: "White" },
      { label: "Usage", value: "Kitchen Storage" },
      { label: "Installation", value: "Cabinet Mount" }
    ],

    // 🔥 NEW (TABLE FORMAT LIKE SCREENSHOT)
    specTable: [
      {
        item: "White PVC Wicket Basket",
        code: "7638",
        size: "-",
        finish: "White"
      }
    ],

   faq: [
  {
    question: "What is a White PVC Wicket Basket?",
    answer:
      "White PVC Wicket Basket is a kitchen storage basket made from durable PVC material designed to store kitchen essentials in an organized and accessible way."
  },
  {
    question: "Where is the White PVC Wicket Basket used?",
    answer:
      "It is commonly used in modular kitchens and cabinets for storing vegetables, groceries, utensils, and other daily kitchen items."
  },
  {
    question: "What are the benefits of PVC kitchen baskets?",
    answer:
      "PVC baskets are lightweight, corrosion-resistant, easy to clean, and provide long-lasting durability for kitchen storage."
  },
  {
    question: "Is the White PVC Wicket Basket easy to maintain?",
    answer:
      "Yes, the basket is easy to clean and maintain, making it ideal for everyday kitchen use."
  }
]
  }

  ,

   {
    code: "7641",
    name: "Honey PVC Wicker Basket",
    category: "basket",

    mainImage: mainImgone,
    thumbnails: [thumb3, thumb4],

    price: "₹2345",
    oldPrice: "₹2799",
    sku: "7641",
    stock: "In Stock",

    catalogue: "/Slimline Price List-2026.pdf",
    inquiry: "https://wa.me/9650100908?text=Honey PVC Basket Inquiry",

    video: "https://www.youtube.com/embed/n19z6iYMfVw",

    short:
      "The Honey PVC Wicker Basket offers a stylish and durable storage solution with a warm honey finish, perfect for modern modular kitchens.",

    features: [
      "Premium PVC wicker design",
      "Elegant honey finish",
      "Waterproof and rust-proof",
      "Strong and long-lasting",
      "Perfect for modular kitchens",
      "Code : 7123, 7384, 7142"
    ],

    // NORMAL SPEC
    specifications: [
      { label: "Material", value: "PVC" },
      { label: "Finish", value: "Honey" },
      { label: "Usage", value: "Kitchen Storage" },
      { label: "Installation", value: "Cabinet Mount" }
    ],

    // TABLE SPEC (IMPORTANT)
    specTable: [
      {
        item: "Honey PVC Wicker Basket",
        code: "7381",
        size: "450",
        finish: "Honey"
      },
      {
        item: "Honey PVC Wicker Basket",
        code: "7383",
        size: "450",
        finish: "Honey"
      },
      {
        item: "Honey PVC Wicker Basket",
        code: "7382",
        size: "600",
        finish: "Honey"
      }
    ],

    faq: [
      {
        question: "What is a Honey PVC Wicker Basket?",
        answer: "It is a modular kitchen storage basket made from high-quality PVC with a honey finish."
      },
      {
        question: "Is it waterproof?",
        answer: "Yes, it is completely waterproof and resistant to moisture."
      },
      {
        question: "Is this basket suitable for modular kitchens?",
        answer: "Yes, it is specially designed for modular kitchen cabinets."
      },
      {
        question: "What can be stored in this basket?",
        answer: "You can store vegetables, utensils, groceries, and daily kitchen essentials."
      },
      {
        question: "Is installation easy?",
        answer: "Yes, it is easy to install inside cabinets with proper fittings."
      }
    ]
  },

  {
    code: "7644",
    name: "Wooden Wicker Basket",
    category: "basket",

    mainImage: mainImgtwo,
    thumbnails: [thumb5, thumb6],

    price: "₹2625",
    oldPrice: "₹2899",
    sku: "7644",
    stock: "In Stock",

    catalogue: "/Slimline Price List-2026.pdf",
    inquiry: "https://wa.me/9650100908?text=Wooden Wicker Basket Inquiry",

    video: "https://www.youtube.com/embed/PM5WhdOWrqo",

    short:
      "The Wooden Wicker Basket combines a natural wooden finish with strong PVC construction, offering a premium and elegant storage solution for modular kitchens.",

    features: [
      "Premium wooden wicker design",
      "Elegant natural wood finish",
      "Waterproof and rust-resistant",
      "Durable and long-lasting build",
      "Perfect for modular kitchen storage",
      "Code : 7644, 7645, 7646"
    ],

    // NORMAL SPECIFICATIONS
    specifications: [
      { label: "Material", value: "PVC Wicker" },
      { label: "Finish", value: "Wooden" },
      { label: "Usage", value: "Kitchen Storage" },
      { label: "Installation", value: "Cabinet Mount" }
    ],

    // SPEC TABLE (LIKE SCREENSHOT)
    specTable: [
      {
        item: "Wooden Wicker Basket",
        code: "7644",
        size: "450",
        finish: "Wooden"
      },
      {
        item: "Wooden Wicker Basket",
        code: "7645",
        size: "600",
        finish: "Wooden"
      },
      {
        item: "Wooden Wicker Basket",
        code: "7647",
        size: "600",
        finish: "Wooden"
      }
    ],

    faq: [
      {
        question: "What is a Wooden Wicker Basket?",
        answer: "It is a modular kitchen basket with a wooden finish made using durable PVC wicker material."
      },
      {
        question: "Is it waterproof?",
        answer: "Yes, it is water-resistant and suitable for kitchen environments."
      },
      {
        question: "Is it suitable for modular kitchens?",
        answer: "Yes, it is designed to fit perfectly in modular kitchen cabinets."
      },
      {
        question: "What items can be stored in this basket?",
        answer: "You can store vegetables, utensils, groceries, and daily kitchen essentials."
      },
      {
        question: "Is installation easy?",
        answer: "Yes, it is easy to install and maintain."
      }
    ]
  },   

   {
    code: "7647",
    name: "Rattan Basket",
    category: "basket",

    mainImage: mainImgthree,
    thumbnails: [thumb7, thumb8],

    price: "₹6693",
    oldPrice: "₹7999",
    sku: "7647",
    stock: "In Stock",

      catalogue: "/Slimline Price List-2026.pdf",
    inquiry: "https://wa.me/9650100908?text=Rattan Basket Inquiry",

    video: "https://www.youtube.com/embed/TJlGBmIX68c",

    short:
      "The Rattan Basket offers a premium natural look with strong and durable construction, making it an ideal storage solution for modern modular kitchens.",

    features: [
      "High-quality rattan finish design",
      "Elegant and premium look",
      "Water-resistant and durable",
      "Strong load-bearing capacity",
      "Perfect for modular kitchen cabinets",
      "Code : 7126, 7127"
    ],

    // NORMAL SPECIFICATIONS
    specifications: [
      { label: "Material", value: "Rattan PVC" },
      { label: "Finish", value: "Rattan" },
      { label: "Usage", value: "Kitchen Storage" },
      { label: "Installation", value: "Cabinet Mount" }
    ],

    // SPEC TABLE (IMPORTANT)
    specTable: [
      {
        item: "Rattan Basket",
        code: "7126",
        size: "600mm",
        finish: "Rattan"
      },
      {
        item: "Rattan Basket",
        code: "7127",
        size: "900mm",
        finish: "Rattan"
      },
     
    ],

    faq: [
      {
        question: "What is a Rattan Basket?",
        answer: "It is a modular kitchen storage basket with a rattan-style finish made from durable materials."
      },
      {
        question: "Is it suitable for kitchen use?",
        answer: "Yes, it is designed specifically for modular kitchen storage."
      },
      {
        question: "Is it waterproof?",
        answer: "Yes, it is resistant to moisture and easy to clean."
      },
      {
        question: "What items can be stored?",
        answer: "You can store vegetables, utensils, groceries, and daily essentials."
      },
      {
        question: "Is installation easy?",
        answer: "Yes, it is simple to install and fits standard cabinets."
      }
    ]
  },
   {
    code: "7650",
    name: "Leather Basket",
    category: "basket",

    mainImage: mainImgfour,
    thumbnails: [thumb9, thumb10],

    price: "₹10460",
    oldPrice: "₹9099",
    sku: "7650",
    stock: "In Stock",

    catalogue: "/Slimline Price List-2026.pdf",
    inquiry: "https://wa.me/9650100908?text=Leather Basket Inquiry",

    video: "https://www.youtube.com/embed/PM5WhdOWrqo",

    short:
      "The Leather Basket delivers a premium and luxurious look with strong construction, making it a perfect storage solution for high-end modular kitchens.",

    features: [
      "Premium leather finish design",
      "Luxury and modern appearance",
      "Water-resistant and durable",
      "Strong and long-lasting build",
      "Ideal for modular kitchen storage",
      "Code : 7650, 7651, 7652"
    ],

    // NORMAL SPECIFICATIONS
    specifications: [
      { label: "Material", value: "Leather Finish PVC" },
      { label: "Finish", value: "Leather" },
      { label: "Usage", value: "Kitchen Storage" },
      { label: "Installation", value: "Cabinet Mount" }
    ],

    // SPEC TABLE (LIKE SCREENSHOT)
    specTable: [
      {
        item: "Leather Basket",
        code: "7700",
        size: "600mm",
        finish: "Leather"
      },
      
      {
        item: "Leather Basket",
        code: "7652",
        size: "900",
        finish: "Leather"
      }
    ],

    faq: [
      {
        question: "What is a Leather Basket?",
        answer: "It is a modular kitchen basket with a premium leather finish for a luxury look."
      },
      {
        question: "Is it suitable for modular kitchens?",
        answer: "Yes, it is specially designed for modern modular kitchen cabinets."
      },
      {
        question: "Is it waterproof?",
        answer: "Yes, it is water-resistant and easy to maintain."
      },
      {
        question: "What items can be stored?",
        answer: "You can store vegetables, groceries, utensils, and kitchen essentials."
      },
      {
        question: "Is installation easy?",
        answer: "Yes, it is simple to install and fits standard cabinet sizes."
      }
    ]
  },
  {
    code: "7653",
    name: "SS Wire Fitment",
    category: "basket",

    mainImage: mainImg9,
    thumbnails: [thumb19, thumb20],

    price: "₹488",
    oldPrice: "₹600",
    sku: "7378",
    stock: "In Stock",

   catalogue: "/Slimline Price List-2026.pdf",
    inquiry: "https://wa.me/919650100908?text=SS Wire Fitment Inquiry",

    video: "https://www.youtube.com/embed/PM5WhdOWrqo",

    short:
      "The SS Wire Fitment is a premium modular kitchen accessory designed for organized storage of plates, utensils, and kitchen essentials with a sleek stainless steel finish.",

    features: [
      "High-quality stainless steel wire construction",
      "Rust-resistant and durable design",
      "Smooth sliding mechanism",
      "Strong load-bearing capacity",
      "Ideal for storing plates and utensils",
      "Perfect for modular kitchen cabinets",
      "Code : 7378, 7379, "
    ],

    // NORMAL SPECIFICATIONS
    specifications: [
      { label: "Material", value: "Stainless Steel" },
      { label: "Finish", value: "Chrome / SS" },
      { label: "Usage", value: "Kitchen Storage" },
      { label: "Installation", value: "Cabinet Mount" }
    ],

    // SPEC TABLE
    specTable: [
      {
        item: "SS Wire Fitment",
        code: "7378",
        size: "",
        finish: "SS"
      },
      {
        item: "SS Wire Fitment",
        code: "7379",
        size: "",
        finish: "SS"
      },
      {
        item: "SS Wire Fitment",
        code: "7380",
        size: "",
        finish: "SS"
      }
    ],

    faq: [
      {
        question: "What is SS Wire Fitment?",
        answer: "It is a modular kitchen accessory made from stainless steel wire for organized storage."
      },
      {
        question: "Is it rust-proof?",
        answer: "Yes, it is made from stainless steel and is rust-resistant."
      },
      {
        question: "What can be stored in this?",
        answer: "You can store plates, utensils, and daily kitchen essentials."
      },
      {
        question: "Is it suitable for modular kitchens?",
        answer: "Yes, it is designed for modern modular kitchen cabinets."
      },
      {
        question: "Is installation easy?",
        answer: "Yes, it is easy to install and maintain."
      }
    ]
  },

  {
  code: "7654",
  name: "Soft Close Wicker Basket Dark Brown",
  category: "basket",

  mainImage: mainImg10,
  thumbnails: [thumb21, thumb22],

  price: "₹1850",
  oldPrice: "₹2400",
  sku: "7788",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Soft%20Close%20Wicker%20Basket%20Dark%20Brown%20Inquiry",

  video: "https://www.youtube.com/embed/r4OHntkrS-c",

  short:
    "The Soft Close Wicker Basket Dark Brown is a stylish and durable storage solution designed for modular kitchens and wardrobes. It features a smooth soft-close mechanism with an elegant dark brown wicker finish for organized and modern storage.",

  features: [
    "Premium dark brown wicker finish",
    "Smooth soft-close sliding mechanism",
    "Strong and durable basket structure",
    "Ideal for kitchen and wardrobe storage",
    "Rust-resistant frame for long-lasting use",
    "Modern and elegant modular design",
    "Easy installation and maintenance"
  ],

  // NORMAL SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Wicker + Metal Frame" },
    { label: "Finish", value: "Dark Brown" },
    { label: "Usage", value: "Kitchen / Wardrobe Storage" },
    { label: "Installation", value: "Cabinet Mount" }
  ],

  // SPEC TABLE
  specTable: [
    {
      item: "Soft Close Wicker Basket Dark Brown",
      code: "7654",
      size: "Standard",
      finish: "Dark Brown"
    }
  ],

  faq: [
    {
      question: "What is Soft Close Wicker Basket Dark Brown?",
      answer:
        "It is a premium storage basket designed for modular kitchens and wardrobes with a soft-close mechanism."
    },
    {
      question: "Does it have a soft-close function?",
      answer:
        "Yes, it comes with a smooth soft-close sliding system for convenient use."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made with a strong metal frame and high-quality wicker material."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is suitable for modular kitchens, wardrobes, and storage cabinets."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it is easy to install and maintain."
    }
  ]
},
];

 
